import { createContext } from "react"

const FacturasContext = createContext({})

export default FacturasContext
